import {
  websocket_connect,
  websocket_disconnect,
  setUnclaimedLeads,
  setLeadStatuses,
  setRelationships,
  setTShirtSizes,
  setResponseLevels,
  setClosingBagOptions,
  setLeadSources,
  setLeadSubSources,
  setEngagementLevel,
  setResponseLevel,
  setLeadStatus,
  setLenderStatus,
  setLenderList,
  setAgentSubsource,
  setReferralList
} from '../state/actions'
import Store,{ State } from '../store'

import { HubConnection,HubConnectionBuilder } from '@microsoft/signalr'

let reconnect : NodeJS.Timeout|null = null

let queue = [] as string[]

let reconnectMethod = (reconnectTime:number) => {
  if(reconnect != null)
  {
    clearTimeout(reconnect)
  }
  reconnect = setTimeout(async () => {
    let state = Store.store.getState()
    // @ts-ignore
    socketConnect(state.auth,reconnectTime * 2)

  }, Math.min(reconnectTime * 2, 30) * 1000)
}

let socket = null as HubConnection | null

export const socketConnect = async (auth:State['auth'],reconnectTime:number) => {
  if(auth.user )
  {
    socket = await (new HubConnectionBuilder()
      .withUrl("/chat",{accessTokenFactory:() => auth.token })
      .withAutomaticReconnect())
      .build()

    socket.on('data',(e: any, _:any) => {
      const temp = JSON.parse(e)
      // console.log("temptemptemptemptemptemptemptemp",temp);
      const messages = Object.entries(temp);
      messages.forEach((message) => {
        switch(message[0])
        {
          case 'unclaimed':
            Store.store.dispatch(setUnclaimedLeads(message[1]))
            break;
          case 'leadStatuses':
            Store.store.dispatch(setLeadStatuses(message[1]))
            break;
          case 'relationships':
            Store.store.dispatch(setRelationships(message[1]))
            break;
          case 'tShirtSizes':
            Store.store.dispatch(setTShirtSizes(message[1]))
            break;
          case 'responseLevels':
            Store.store.dispatch(setResponseLevels(message[1]))
            break;
          case 'closingBagOptions':
            Store.store.dispatch(setClosingBagOptions(message[1]))
            break;
          case 'leadSources':
            Store.store.dispatch(setLeadSources(message[1]))
            break;
          case 'leadSubSources':
            Store.store.dispatch(setLeadSubSources(message[1]))
            break;
          case 'leadenagementlevel':
            Store.store.dispatch(setEngagementLevel(message[1]))
            break;
          case 'leadresponselevel':
              Store.store.dispatch(setResponseLevel(message[1]))
              break;
          case 'leadstatuslevel':
            Store.store.dispatch(setLeadStatus(message[1]))
            break;
          case 'lenderstatuslevel':
            Store.store.dispatch(setLenderStatus(message[1]))
              break;
          case 'lenderslistlevel':
            Store.store.dispatch(setLenderList(message[1]))
              break;
          case 'leadSubSourcesForAgents':
            Store.store.dispatch(setAgentSubsource(message[1]))
              break;
          case 'referrallist':
            Store.store.dispatch(setReferralList(message[1]))
              break;
          default:
            console.log(message[0],message[1])
        }
      })
    })

    socket
      .start()
      .then(() => {
        Store.store.dispatch(websocket_connect())
        queue.forEach((v) => {
          if(socket)
          {
            socket.invoke('request',v)
          }
        })
        queue = []
      })
      .catch(() => {
        reconnectMethod(1)
      })
    socket.onclose(() => {
      Store.store.dispatch(websocket_disconnect())
      socket = null
      // @ts-ignore
      if(Store.store.getState().auth.user)
      {
        reconnectMethod(reconnectTime)
      }
    })
  }
  else
  {
    reconnectMethod(reconnectTime)
  }
}

export const closeConnection = () => {
  if(socket !== null)
  {
    socket.stop()
    socket = null
  }
}

const send = (obj:object) => {
  let message = JSON.stringify(obj)
  if(socket && socket.state == 'Connected')
  {
    socket.invoke('request',message)
  }
  else
  {
    queue = queue.concat([message])
  }
}